import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import authService from "@/services/auth";

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '*',
    redirect: '/'
  },
  {
    path: '/',
    name: 'home',
    redirect: '/general',
    beforeEnter: authGuard,
    component: () => import('../views/HomeView.vue'),
    children: [
      {
        path: 'general',
        name: 'general',
        component: () => import('../views/GeneralView.vue'),
      },
      {
        path: 'registration',
        name: 'registration',
        component: () => import('../views/NewRegistrationView.vue'),
      }
    ]
  },
  {
    path: '/login',
    name: 'login',
    component:  () => import('../views/LoginView.vue'),
    beforeEnter: loginGuard
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component:  () => import('../views/ResetPasswordView.vue'),
  },
]

// eslint-disable-next-line @typescript-eslint/no-explicit-any
async function loginGuard(to: any, from: any, next: any) {
  const user = authService.user;
  if (to.name === 'login' && user) {
    next(`general`);
  } else {
    next();
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
async function authGuard(to: any, from: any, next: any) {
  const user = authService.user;
  if (user) {
    next();
  } else {
    next('/login');
  }
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
